import { View, Utils } from '../vendor/kerneljs';
import * as tracking from '../../../booking/helpers/tracking'

let lastPressed;
let filterContent;
let hideAsDefault;

function filter(filterTag) {
    let filterContentArray = [...filterContent]
    let unfilterContentArray = filterContentArray.filter(e => e.classList.contains(filterTag))
    filterContentArray = filterContentArray.filter(e => !e.classList.contains(filterTag))

    unfilterContentArray.forEach(prodBox => prodBox.style.display = "inline")
    filterContentArray.forEach(prodBox => prodBox.style.display = "none")
}

function unfilter() {
    let filterContentArray = [...filterContent]
    filterContentArray.forEach(prodBox => {
        if (hideAsDefault.includes(prodBox)) {
            prodBox.style.display = "none"
        } else {
            prodBox.style.display = "inline"
        }
    })
}

function trackFilterClick(filterTag) {
    tracking.trackParkingEngagementClick('parking - products & prices', `filter - ${filterTag}`)
}

const FilterButton = View.extend({
    events: {
        'click': 'filterProducts',
    },
    filterProducts: function (elem) {
        if (this.el === lastPressed) {
            lastPressed.classList.remove("is-active")
            lastPressed = undefined

            unfilter()
        } else if (this.el !== lastPressed) {
            if (lastPressed) {
                lastPressed.classList.remove("is-active")
                lastPressed = undefined

                unfilter()
            }

            lastPressed = this.el
            let filterTag = this.el.className.match(/js--filter--\S*/)[0]

            this.el.classList.add("is-active")
            filter(filterTag)
            trackFilterClick(filterTag.replace('js--filter--', '').replace('-', ' '))
        }
    }
});


(function () {
    if (filterContent === undefined) {
        filterContent = [...Utils.find(".js--filter-content")].map(content => [...content.children]).flat(2).filter(children => children.className.match(/js--filter*/))
        hideAsDefault = [...Utils.find(".js--filter-hide-as-default")]
    }

    Utils.each(Utils.find('.js--product-filter'), function (elem) {
        new FilterButton({ el: elem });
    });

    // couldn't add the event using the View.extend method
    Utils.each(Utils.find('.js--reveal--light'), function (elem) {
        elem.addEventListener('change', (e) => {
            let filterTag = e.target.selectedOptions[0].value;
            unfilter()
            if (filterTag) {
                filter(filterTag)
            }
        })
    })
})();

export default FilterButton;